import styled from 'styled-components'

export const TabContentTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 0;
  font-family: ${props => props.theme.texts.titleM.fontFamily};
  font-size: ${props => props.theme.texts.titleM.fontSize};
  font-weight: 600;
  padding-bottom: ${props => props.theme.spacing.sp4};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  color: ${props => props.theme.colors.outline.default};
  margin-bottom: ${props => props.theme.spacing.sp32};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const MenuContainer = styled.div`
  margin-left: auto;
`

export const MenuOptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
